var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 78,
    viewBox: "0 0 98 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 77,
    rx: 2.5,
    stroke: "#B7B7B7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 54,
    width: 10,
    height: 3,
    fill: "#B7B7B7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 39,
    width: 10,
    height: 3,
    fill: "#B7B7B7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 24,
    width: 10,
    height: 3,
    fill: "#B7B7B7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 10,
    height: 3,
    fill: "#B7B7B7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 15,
    width: 10,
    height: 49,
    fill: "#B7B7B7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 31,
    width: 10,
    height: 33,
    fill: "#B7B7B7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 45,
    width: 10,
    height: 19,
    fill: "#B7B7B7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 67,
    width: 10,
    height: 3,
    fill: "#B7B7B7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 67,
    width: 10,
    height: 3,
    fill: "#B7B7B7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 67,
    width: 10,
    height: 3,
    fill: "#B7B7B7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPlaceholder);
export default __webpack_public_path__ + "static/media/chart-placeholder.802912cd9a5981aa5ffc928a19810433.svg";
export { ForwardRef as ReactComponent };